import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms';
import { DATE_PERIOD_FILTER_OPTIONS } from '@/lib/constants';
import { cn } from '@/lib/utils';

interface DatePeriodSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  triggerClassName?: string;
  placeholder?: string;
}

export const DatePeriodSelect = ({
  value,
  onValueChange,
  triggerClassName,
  placeholder = 'Select date range',
}: DatePeriodSelectProps) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={cn('w-40', triggerClassName)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {DATE_PERIOD_FILTER_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
